import {useGlobalState} from "../GlobalState";
import {useCallback} from "react";
import {isValidDateObject} from "../services/date/validators";


const useAccommodationUnitSettings = () => {
    const {accommodationUnitsSettings} = useGlobalState();

    // Function to get the check-in from a set of accommodation unit.
    // It returns the latest check-in from date.
    const getCheckInFrom = useCallback(({accommodationUnitIds}) => {
        let checkInFromDates = accommodationUnitsSettings
            .filter(aS => accommodationUnitIds.includes(aS.accommodationUnitId))
            .map(aS => aS.checkInFrom)
            .filter(date => isValidDateObject(date));

        if (checkInFromDates.length > 0) {
            return checkInFromDates.reduce((latest, current) => {
                return current > latest ? current : latest;
            });
        }
        return null;
    }, [accommodationUnitsSettings]);

    // Function to get the check-out before date from a set of accommodation unit.
    // It returns the earliest check-out before date.
    const getCheckOutBefore = useCallback(({accommodationUnitIds}) => {
        let checkOutBeforeDates = accommodationUnitsSettings
            .filter(aS => accommodationUnitIds.includes(aS.accommodationUnitId))
            .map(aS => aS.checkOutBefore)
            .filter(date => isValidDateObject(date));

        if (checkOutBeforeDates.length > 0) {
            return checkOutBeforeDates.reduce((earliest, current) => {
                return current < earliest ? current : earliest;
            });
        }
        return null;
    }, [accommodationUnitsSettings]);

    return {
        getCheckInFrom,
        getCheckOutBefore
    }
}


export default useAccommodationUnitSettings;